import SpinTypes from '../../const/SpinTypesEnum';
import { WalkDirection } from "../../views/WinSymbolsView";
import { IBonusData, ICustomData } from "./ICustomData";

export default interface ISpinData extends ICustomData {
    featureMode?: number;
    freespinSelectScreen?: boolean;
    freespinsNum?: number;
    totalFreeSpins?: number;
    freeSpinRetriggered?: number;
    freespinsWon?: number;
    freespinWinnings?: number;
    freespinsFlags?: { [flagName: string]: boolean };
    winAmount?: number;
    currentWin?: number;
    accumulatedWin?: number;
    overlays?: IOverlayData[];
    bonuses?: IBonusData[];
    reelStopSymbols: number[][];
    reelFinalSymbols: number[][]; // SYMBOLS TO BE VISIBLE WHEN AFTER ALL BONUSES
    spinification?: ISpinificationData;
    winsData?: IWinData[];
    winsMultiplier?: number;
    winsWildMultiplier?: number;
    skatterWin?: number;
    isFree?: boolean;
    reelSetIndex?: number;
    reelSets?: any[][][];
    stopPositions?: number[];
    // [CASCADE] Cascades before the final symbols show
    cascades?: ISpinData[];
    // [CASCADE] Currently active cascade index
    cascadeIndex?: number;
    // [CASCADE] All symbols participating in the current cascade's wins - indexes
    cascadeWinOffsets?: number[];
     // [CASCADE] All symbols participating in the current cascade's explodes - indexes (might not be wins)
    cascadeExplodesOffsets?: number[];
    // [TOKENS] Collected tokens - could be used for various features
    tokensCount?: {};
    // [RE-SPIN] ReSpin data
    reSpinData?: IReSpinData;
    reelHeight?: number;
    spinEnded?: boolean;
    symbolReplacements?:
        | { [original: string]: any }
        | { [original: number]: any };
    bonusInfo?: any[];
    roundType?: SpinTypes | string;
}

export interface ISpinificationData {
    spinificationIndex?: number;
    spinificationEndIndex?: number;
    spinificationSymbolId?: number;
    armed?: boolean;
}

export interface IOverlayData {
    type: OverlayType;
    direction?: WalkDirection;
    symbolPosition: number[][];
    initPositions?: ISymbolPosition[];
    path?:ISymbolPosition[];
    customData?:any;
}

export interface ISymbolPosition {
    row: number;
    reel: number;
}

export enum OverlayType {
    Expanding = "Expanding",
    Locked = "Locked",
    Walking = "Walking",// one step
    Moving = "Moving", // can move anywhere along a path
    Random = "Random",
    Custom = "Custom",
}

export interface IWinData {
    lineId?: number;
    isWay: boolean;
    winSymId?: number;
    winType?: string;
    creditsWon?: number | undefined;
    multiplier?: number | undefined;
    wildMultiplier?: number | undefined;
    coordinates?: { x: number; y: number }[];
    normalLineWin?: boolean;
    multiplyWin?: boolean;
    winReels: number[];
    winSymbols: number[];
    bonusRound?: boolean;
    isFreespinWin?: boolean;
    freespins?: number;
    featureTrigger?: string;
}

export interface IReSpinData {
    awarded: number;
    reTriggered: number;
    win: number;
    remaining: number;
    reSpinsList?: any[];
}
